<template>
  <div class="wrapper_box">
    <div class="header">
      <div class="select" @click="showQuarter()">
        <span>{{quarterName}}</span>
        <div class="select-icon"></div>
      </div>
    </div>
    <div class="content_list" v-if=" authB==='B' ">
      <div v-if="listDesc.nameB " class="list_header">{{listDesc.nameB.title}}</div>
      <div class="list line_top" v-if="listDesc.nameB">
        <div class="items" v-for="item in listDesc.nameB.data" :key="item.type">
          <template v-if=" item.type === authB1 ">
            <div class="left">
              <div class="left_title">{{item.name}}</div>
              <div class="left_go">
                <div @click="goDetail(item.type)">查看各州市分数详情</div>
                <div class="imgBjt"></div>
              </div>
            </div>
            <div class="right">
              <btnauth custype="audit" :year="year" :quarter="quarter"  :authlist="authlist">
                <span class="status" v-if="item.isNull&&item.isNull==='1'">暂无数据</span>
                <span class="status" v-else-if="item.audit==='1'">已审核</span>
                <van-button
                  v-else-if=" authB1_exam === 'OPERATION06' "
                  type="primary"
                  class="btn"
                  size="small"
                  @click="adiutBtn(item)"
                >审核</van-button>
              </btnauth>
            </div>
          </template>
          <template v-if=" item.type === authB2 ">
            <div class="left">
              <div class="left_title">{{item.name}}</div>
              <div class="left_go">
                <div @click="goDetail(item.type)">查看各州市分数详情</div>
                <div class="imgBjt"></div>
              </div>
            </div>
            <div class="right">
              <btnauth custype="audit" :year="year" :quarter="quarter"  :authlist="authlist">
                <span class="status" v-if="item.isNull&&item.isNull==='1'">暂无数据</span>
                <span class="status" v-else-if="item.audit==='1'">已审核</span>
                <van-button
                  v-else-if=" authB2_exam === 'OPERATION06' "
                  type="primary"
                  class="btn"
                  size="small"
                  @click="adiutBtn(item)"
                >审核</van-button>
              </btnauth>
            </div>
          </template>
          <template v-if=" item.type === authB3 ">
            <div class="left">
              <div class="left_title">{{item.name}}</div>
              <div class="left_go">
                <div @click="goDetail(item.type)">查看各州市分数详情</div>
                <div class="imgBjt"></div>
              </div>
            </div>
            <div class="right">
              <btnauth custype="audit" :year="year" :quarter="quarter"  :authlist="authlist">
                <span class="status" v-if="item.isNull&&item.isNull==='1'">暂无数据</span>
                <span class="status" v-else-if="item.audit==='1'">已审核</span>
                <van-button
                  v-else-if=" authB3_exam === 'OPERATION06' "
                  type="primary"
                  class="btn"
                  size="small"
                  @click="adiutBtn(item)"
                >审核</van-button>
              </btnauth>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="content_list" v-if=" authG === 'G' ">
      <div class="list line_top">
        <div class="items">
          <div class="left">
            <div v-if="listDesc.nameG " class="left_title">{{listDesc.nameG.name}}</div>
            <div class="left_go">
              <div @click="goDetail(listDesc.nameG.type)">查看各州市分数详情</div>
              <div class="imgBjt"></div>
            </div>
          </div>
          <div class="right">
            <btnauth custype="audit" :year="year" :quarter="quarter"  :authlist="authlist">
              <span class="status" v-if="listDesc.nameG&&listDesc.nameG.isNull&&listDesc.nameG.isNull==='1'">暂无数据</span>
              <span class="status" v-else-if="listDesc.nameG&&listDesc.nameG.audit==='1'">已审核</span>
              <van-button
                v-else-if=" authG_exam === 'OPERATION06' "
                type="primary"
                class="btn"
                size="small"
                @click="adiutBtn(listDesc.nameG)"
              >审核</van-button>
            </btnauth>
          </div>
        </div>
      </div>
    </div>
    <div class="content_list" v-if=" authH === 'H' ">
      <div class="list line_top">
        <div class="items">
          <div class="left">
            <div v-if="listDesc.nameH " class="left_title">{{listDesc.nameH.name}}</div>
            <div class="left_go">
              <div @click="goDetail(listDesc.nameH.type)">查看各州市分数详情</div>
              <div class="imgBjt"></div>
            </div>
          </div>
          <div class="right">
            <btnauth custype="audit" :year="year" :quarter="quarter"  :authlist="authlist">
              <span class="status" v-if="listDesc.nameH&&listDesc.nameH.isNull&&listDesc.nameH.isNull==='1'">暂无数据</span>
              <span class="status" v-else-if="listDesc.nameH&&listDesc.nameH.audit==='1'">已审核</span>
              <van-button
                v-else-if=" authH_exam === 'OPERATION06' "
                type="primary"
                class="btn"
                size="small"
                @click="adiutBtn(listDesc.nameH)"
              >审核</van-button>
            </btnauth>
          </div>
        </div>
      </div>
    </div>
    <div class="content_list" v-if=" authI === 'I' ">
      <div class="list line_top">
        <div class="items">
          <div class="left">
            <div v-if="listDesc.nameI " class="left_title">{{listDesc.nameI.name}}</div>
            <div class="left_go">
              <div @click="goDetail(listDesc.nameI.type)">查看各州市分数详情</div>
              <div class="imgBjt"></div>
            </div>
          </div>
          <div class="right">
            <btnauth custype="audit" :year="year" :quarter="quarter"  :authlist="authlist">
              <span class="status" v-if="listDesc.nameI&&listDesc.nameI.isNull&&listDesc.nameI.isNull==='1'">暂无数据</span>
              <span class="status" v-else-if="listDesc.nameI&&listDesc.nameI.audit==='1'">已审核</span>
              <van-button
                v-else-if=" authI_exam ==='OPERATION06' "
                type="primary"
                class="btn"
                size="small"
                @click="adiutBtn(listDesc.nameI)"
              >审核</van-button>
            </btnauth>
          </div>
        </div>
      </div>
    </div>
    <div class="content_list" v-if=" authJ === 'J' ">
      <div class="list line_top">
        <div class="items">
          <div class="left">
            <div v-if="listDesc.nameJ " class="left_title">{{listDesc.nameJ.name}}</div>
            <div class="left_go">
              <div @click="goDetail(listDesc.nameJ.type)">查看各州市分数详情</div>
              <div class="imgBjt"></div>
            </div>
          </div>
          <div class="right">
            <btnauth custype="audit" :year="year" :quarter="quarter" :authlist="authlist">
              <span class="status" v-if="listDesc.nameJ&&listDesc.nameJ.isNull&&listDesc.nameJ.isNull==='1'">暂无数据</span>
              <span class="status" v-else-if="listDesc.nameJ&&listDesc.nameJ.audit==='1'">已审核</span>
              <van-button
                v-else-if=" authJ_exam === 'OPERATION06' "
                type="primary"
                class="btn"
                size="small"
                @click="adiutBtn(listDesc.nameJ)"
              >审核</van-button>
            </btnauth>
          </div>
        </div>
      </div>
    </div>
    <common-picker
      ref="commonPickerQuarter1"
      :typeList="newQuarterList"
      :cols="cols1"
      @getTypeValue="getQuarterValue"
    ></common-picker>
    <confirm-dialog
      v-if="isShow"
      :title="dialogTitle"
      :content="dialogContent"
      :cancelTxt="cancelBtn"
      :confirmTxt="confirmBtn"
      @confirm="confirm"
      @cancel="cancel"
    ></confirm-dialog>
  </div>
</template>
<script>
import commonPicker from "../../../components/base/commonPicker.vue";
import confirmDialog from "../components/confirmDialog.vue";
import api from "@/service/modules/appraiseNew.js";
import icon from "@/assets/appraise/icon_ts_gx@3x.png";
import commonAPI from "../../../utils/common";
// import btnauth from "../appraiseNew/components/btnauth";
import btnauth from "../appraiseNew/components/btnauth_new";
export default {
  beforeRouteEnter(to, from, next){
    next(vm => {
      if(from.fullPath === '/appraise/index') {
        // 如果是从考核首页进来的就晴空vuex中的季度信息
        vm.$store.commit('appraise/setCurrentQuarter', {});
      }
    });
  },
  components: {
    commonPicker,
    confirmDialog,
    btnauth,
  },
  data() {
    return {
      newQuarterList: [],
      cols1: 1,
      quarterName: "",
      area: this.$route.query.area,
      year: this.$route.query.year,
      quarter: this.$route.query.quarter,
      oporateItem: {}, // 当前操作项
      complainQuarter: "",
      quaterList: [],
      listDesc: {}, // 列表数据
      dialogTitle: "提示",
      dialogContent: "是否确定所有州市数据及扣分准确无误",
      cancelBtn: "取消",
      confirmBtn: "确定",
      isShow: false,
      // 权限字段
      authB: "",
      authG: "",
      authH: "",
      authI: "",
      authJ: "",
      // 1+16+129+x 三个子项权限
      authB1: "",
      authB2: "",
      authB3: "",

      // 审核权限
      authB1_exam: "",
      authB2_exam: "",
      authB3_exam: "",
      authG_exam: "",
      authH_exam: "",
      authI_exam: "",
      authJ_exam: "",

      authlist: {}
    };
  },
  created() {
    // this.initdata();
    console.log('-----batchReview生命周期created');
  },
  mounted(){
    this.initdata();
    console.log('-----batchReview生命周期mounted');
    const _this = this;
     window.yyn.registerAsyn('onShow', function () {
                    console.log('批量审核----registerAsyn:onshow')
                    _this.initdata();
                })
  },
  methods: {
    
    async initdata() {
      console.log('-----初始化数据');
      await this.queryQuarters();
      await this.getAuthbtn();
      const childAuth = commonAPI.getAuthorityList("ASSESS_SCORE");
      console.log("-----父项权限:", childAuth);
      if (childAuth) {
        for (let i = 0; i < childAuth.length; i++) {
          if (childAuth[i].assessType === "B") {
            this.authB = "B";
            const childList = childAuth[i].children;
            if (childList && childList.length > 0) {
              for (let j = 0; j < childList.length; j++) {
                if (childList[j].assessType === "B1") {
                  this.authB1 = "B1";
                  if (
                    childList[j].operationType &&
                    childList[j].operationType.length > 0
                  ) {
                    this.authB1_exam =this.fixOperationType( childList[j].operationType )
                  }
                }
                if (childList[j].assessType === "B2") {
                  this.authB2 = "B2";
                  if (
                    childList[j].operationType &&
                    childList[j].operationType.length > 0
                  ) {
                    this.authB2_exam =this.fixOperationType( childList[j].operationType )
                  }
                }
                if (childList[j].assessType === "B3") {
                  this.authB3 = "B3";
                  if (
                    childList[j].operationType &&
                    childList[j].operationType.length > 0
                  ) {
                    this.authB3_exam = this.fixOperationType( childList[j].operationType )
                  }
                }
              }
            }
          }
          if (childAuth[i].assessType === "G") {
            this.authG = "G";
            if (
              childAuth[i].operationType &&
              childAuth[i].operationType.length > 0
            ) {
              this.authG_exam =this.fixOperationType( childAuth[i].operationType )
            }
          }
          if (childAuth[i].assessType === "H") {
            this.authH = "H";
            if (
              childAuth[i].operationType &&
              childAuth[i].operationType.length > 0
            ) {
              this.authH_exam = this.fixOperationType( childAuth[i].operationType )
            }
          }
          if (childAuth[i].assessType === "I") {
            this.authI = "I";
            if (
              childAuth[i].operationType &&
              childAuth[i].operationType.length > 0
            ) {
              this.authI_exam = this.fixOperationType( childAuth[i].operationType )
            }
          }
          if (childAuth[i].assessType === "J") {
            this.authJ = "J";
            if ( childAuth[i].operationType && childAuth[i].operationType.length > 0 ) {
              this.authJ_exam = this.fixOperationType( childAuth[i].operationType )
            }
          }
        }
        console.log(this.authJ_exam , "authb");
      }
    },
    fixOperationType(data){
       for( let i = 0; i< data.length; i++){
          if(data[i].value === 'OPERATION06'){
             return 'OPERATION06'
          }
       }
       return ""
    },
    getAuthbtn(){
      return new Promise( (resolve, reject) =>{
        api.getAuthtoBTN({}).then( (res) => {
          if( res.ret == 0){
             this.authlist = res.data;
          }
          resolve(true);
        });
      })
    },
    // 获取季度下拉
    queryQuarters() {
      return new Promise((resolve, reject) => {
        this.quaterList = []
        this.newQuarterList = []
        api.queryQuarters({}).then((res) => {
          if (res.ret === 0) {
            console.log('--------季度数据:', res);
            let current = {};
            this.quaterList = res.data.reverse().map((item) => {
              for (let key in item) {
                current = {
                  code: key,
                  text: item[key],
                };
              }
              return current;
            });
            this.newQuarterList = [this.quaterList];
            // let currentQuarter = this.$store.state.appraise.currentQuarter;
            // console.log('------当前季度:', currentQuarter);
            // if(currentQuarter&&currentQuarter.code) {
            //   this.quarterName = currentQuarter.text;
            //   this.yearQuarter = currentQuarter.code;
            //   this.year = currentQuarter.code.substr(0, 4); // 取年
            //   this.quarter = currentQuarter.code.substring(5); // 取季度
            //   this.complainQuarter = currentQuarter.complainQuarter; // 选择季度英文值
            // }else {
            //   this.getQuarterValue(this.quaterList);
            // }
             this.getQuarterValue(this.quaterList);
            this.queryCheckList();
            resolve(true);
          }
        });
      });
    },
    showQuarter() {
      // 唤起季度选择组件
      this.$refs.commonPickerQuarter1.showPicker();
    },
    getQuarterValue(value) {
      // 选择季度
      this.quarterName = value[0].text;
      this.yearQuarter = value[0].code;
      this.year = value[0].code.substr(0, 4); // 取年
      this.quarter = value[0].code.substring(5); // 取季度
      this.complainQuarter = value[0].complainQuarter; // 选择季度英文值
      // this.$store.commit('appraise/setCurrentQuarter', {
      //   text: this.quarterName,
      //   code: this.yearQuarter
      // })
      this.queryCheckList();
    },
    // 查询批量审核列表
    queryCheckList() {
      let params = {
        year: this.yearQuarter.split("-")[0],
        quarter: this.yearQuarter.split("-")[1],
        area: this.area,
      };
      api.queryCheckList(params).then((res) => {
        // console.log("-----审核列表：", res);
        if (res.ret === 0) {
          this.listDesc = res.data;
        }
      });
    },
    // 确定
    confirm() {
      let type = this.oporateItem.type;
      if (type === "B1" || type === "B2" || type === "B3") {
        this.complainDealCheck();
      } else if (type === "G") {
        this.touristComplainRateCheck();
      } else if (type === "H") {
        this.touristComplainRate();
      } else if (type === "I") {
        this.complainDoneSatisfy();
      } else if (type === "J") {
        this.touristExpSatisfy();
      }
      this.isShow = !this.isShow;
    },
    // 取消
    cancel() {
      this.isShow = !this.isShow;
    },
    // 点击审核按钮
    adiutBtn(item) {
      this.oporateItem = item;
      this.isShow = !this.isShow;
    },
    // 游客投诉处置体系运行情况审核操作审核
    complainDealCheck(item) {
      let params = {
        dealType: this.oporateItem.type,
        year: this.yearQuarter.split("-")[0],
        quarter: this.yearQuarter.split("-")[1],
      };
      api.complainDealCheck(params).then((res) => {
        if (res.ret === 0) {
          this.$Toast({
            message: "审核成功",
            icon,
          });
          this.queryCheckList();
        }
      });
    },
    // 游客投诉率审核
    touristComplainRateCheck(item) {
      let params = {
        dealType: this.oporateItem.type,
        year: this.yearQuarter.split("-")[0],
        quarter: this.yearQuarter.split("-")[1],
      };
      api.touristComplainRateCheck(params).then((res) => {
        if (res.ret === 0) {
          this.$Toast({
            message: "审核成功",
            icon,
          });
          this.queryCheckList();
        }
      });
    },
    // 游客投诉率
    touristComplainRate(item) {
      let params = {
        dealType: this.oporateItem.type,
        year: this.yearQuarter.split("-")[0],
        quarter: this.yearQuarter.split("-")[1],
      };
      api.touristComplainRate(params).then((res) => {
        if (res.ret === 0) {
          this.$Toast({
            message: "审核成功",
            icon,
          });
          this.queryCheckList();
        }
      });
    },
    // 游客投诉处置效率
    complainDealCheck(item) {
      let params = {
        dealType: this.oporateItem.type,
        year: this.yearQuarter.split("-")[0],
        quarter: this.yearQuarter.split("-")[1],
      };
      api.complainDealCheck(params).then((res) => {
        if (res.ret === 0) {
          this.$Toast({
            message: "审核成功",
            icon,
          });
          this.queryCheckList();
        }
      });
    },
    // 游客投诉处置满意度
    complainDoneSatisfy(item) {
      let params = {
        dealType: this.oporateItem.type,
        year: this.yearQuarter.split("-")[0],
        quarter: this.yearQuarter.split("-")[1],
      };
      api.complainDoneSatisfy(params).then((res) => {
        if (res.ret === 0) {
          this.$Toast({
            message: "审核成功",
            icon,
          });
          this.queryCheckList();
        }
      });
    },
    // 游客体验满意度
    touristExpSatisfy(item) {
      let params = {
        dealType: this.oporateItem.type,
        year: this.yearQuarter.split("-")[0],
        quarter: this.yearQuarter.split("-")[1],
      };
      api.touristExpSatisfy(params).then((res) => {
        if (res.ret === 0) {
          this.$Toast({
            message: "审核成功",
            icon,
          });
          this.queryCheckList();
        }
      });
    },
    // 去详情
    goDetail(type) {
      this.$router.push(
        `/appraise/tabBatch?type=${type}&year=${
          this.yearQuarter.split("-")[0]
        }&quarter=${this.yearQuarter.split("-")[1]}`
      );
    },
  },
};
</script>
<style lang="less" scoped>
.wrapper_box {
  padding: 24px 12px;
  .header {
    .select {
      display: flex;
      align-items: center;
      span {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        padding-right: 4px;
      }

      .select-icon {
        width: 6px;
        height: 4px;
        background: url("../../../assets/image/xiala.png") no-repeat;
        background-size: 6px 4px;
      }
    }
  }
  .content_list {
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.06);
    border-radius: 3px;
    margin-top: 12px;
    .list_header {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      padding: 16px;
    }
    .list {
      // padding: 0 16px;
      .left {
        .left_title {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
          line-height: 14px;
        }
        .left_go {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(54, 179, 116, 1);
          line-height: 12px;
          margin-top: 12px;
          display: flex;
          align-items: center;
          .imgBjt {
            width: 12px;
            height: 12px;
            background: url("../../../assets/appraise/right.png") no-repeat;
            background-size: 100% 100%;
          }
        }
      }
      .right {
        display: flex;
        align-items: center;
      }
    }
  }
}
.items {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ededed;
  padding: 0 16px;
  .left {
    margin-bottom: 16px;
    padding-top: 15px;
  }
}
.items:last-child {
  border: 0;
}
.status {
  display: inline-block;
  width: 60px;
  color: #999;
  font-size: 12px;
  text-align: center;
}
</style>
